<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购付款</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 审核采购付款 strat -->
      <el-tab-pane label="审核采购付款" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clickSearch" placeholder="请输入合同编号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.projectname" @keyup.enter.native="clickSearch" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.shenqingdanwei" @keyup.enter.native="clickSearch" placeholder="请输入申请单位"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.reviewstatus" placeholder="请选择审核状态" class="select">
              <el-option label="请选择审核状态" value="-1"></el-option>
              <el-option label="审核被拒绝" value="0"></el-option>
              <el-option label="待采购审核" value="1"></el-option>
              <el-option label="待财务审核" value="2"></el-option>
              <el-option label="待总经理审核" value="3"></el-option>
              <el-option label="已审核" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.paystatus" placeholder="请选择支付状态" class="select">
              <el-option label="请选择支付状态" value="-1"></el-option>
              <el-option label="待支付" value="1"></el-option>
              <el-option label="已支付" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}" height="440">
          <el-table-column prop="Orderid" label="合同编号" width="200"></el-table-column>
          <el-table-column prop="Contractamount" label="合同金额" width="100"></el-table-column>
          <el-table-column prop="Amount" label="本次申请付款金额" width="150"></el-table-column>
          <!-- <el-table-column prop="Purchasecompany" label="采购单位" width="300"></el-table-column> -->
          <el-table-column prop="Projectname" label="项目名称" width="200"></el-table-column>
          <el-table-column prop="Bomname" label="物料名称" width="300"></el-table-column>
          <el-table-column prop="Suppliername" label="供应商名称" width="300"></el-table-column>
          <el-table-column prop="Contractnum" label="合同数量" width="100"></el-table-column>
          <el-table-column prop="Shenqingdanwei" label="申请单位" width="200"></el-table-column>
          <el-table-column prop="Shenqingshijian" label="申请时间" width="200"></el-table-column>
<!--          <el-table-column prop="Paymentterms" label="合同付款条件" width="200"></el-table-column>
          <el-table-column prop="Paymenttime" label="合同付款时间" width="200"></el-table-column>
          <el-table-column prop="Paymentamount" label="合同付款金额" width="150"></el-table-column> -->
          <el-table-column prop="ReviewstatusName" label="审核状态" width="150"></el-table-column>
          <el-table-column prop="Opinion" label="审核意见" width="150"></el-table-column>
          <el-table-column prop="Reply" label="答复审核意见" width="150"></el-table-column>
          <el-table-column prop="PaystatusName" label="支付状态" width="150"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200" fixed="right">
            <template v-slot="scope">
              <el-button v-if="scope.row.Reviewstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button v-if="scope.row.Reviewstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Reviewstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe0(scope.row)">再次提交审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 1 && SubRule_Erp6PurchaseOrderFuKuanShenHe_CaiGou" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe123(scope.row,1)">采购审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 2 && SubRule_Erp6PurchaseOrderFuKuanShenHe_CaiWu" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe123(scope.row,2)">财务审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 3 && SubRule_Erp6PurchaseOrderFuKuanShenHe_Zong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe123(scope.row,3)">总经理审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 4 && scope.row.Paystatus == 1 && SubRule_Erp6PurchaseOrderFuKuanShenHe_ChuNa" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickChuNa(scope.row)">设置为已支付</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 审批 start -->
        <el-dialog
          title=""
          :visible.sync="dialogShenPi"
          width="880px">
          <el-form :model="modelShenPi" ref="modelShenPi" label-width="170px">
            <el-form-item label="审批意见(可选)" class="addAdminForm">
              <el-input v-model="modelShenPi.opinion" placeholder="如果拒绝,请填写审批意见"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="ShenHeOK">同意</el-button>
              <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 审批 end -->

        <el-dialog
          title="再次提交审核"
          :visible.sync="dialogSubmitAgain"
          width="35%">
          <el-form :model="modelSubmitAgain" ref="modelSubmitAgain" label-width="170px">
            <el-form-item label="答复审批意见" class="addAdminForm">
              <el-input v-model="modelSubmitAgain.reply" placeholder="请填写答复"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="SubmitAgain">提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 修改付款申请 start -->
        <el-dialog title="修改付款申请" :visible.sync="dialogFuKuanShenQing" width="600px">
          <el-form :model="modelFuKuanShenHe" ref="addMechanismRef" label-width="150px">
            <el-form-item label="申请单位" class="addAdminForm">
              <el-input v-model="modelFuKuanShenHe.shenqingdanwei" placeholder="请输入申请单位"></el-input>
            </el-form-item>
            <el-form-item label="申请时间" class="addAdminForm">
              <el-date-picker v-model="modelFuKuanShenHe.shenqingshijian" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="本次申请付款金额" class="addAdminForm">
              <el-input v-model="modelFuKuanShenHe.amount" placeholder="请输入本次申请付款金额"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="apiEditErp6PurchaseOrderFuKuanShenHe">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 修改付款申请 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 审核采购付款 end -->

      <!-- start -->
      <el-tab-pane label="添加采购付款" name="second" v-if="SubRule_Erp6PurchaseOrderFuKuanShenHe_Add">
        <Erp6PurchaseOrderFuKuanShenHeAdd ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></Erp6PurchaseOrderFuKuanShenHeAdd>
      </el-tab-pane>
      <!-- end -->

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import Erp6PurchaseOrderFuKuanShenHeAdd from '@/componentsSubVue/Erp6PurchaseOrderFuKuanShenHeAdd.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf,
    Erp6PurchaseOrderFuKuanShenHeAdd
  },
  name: 'MyErp6PurchaseOrderFuKuanShenHe',
  data () {
    return {
      useriderp: 0,
      activeName: 'first',
      modelShenPi: {
        id: 0,
        opinion: ''
      },
      modelSubmitAgain: {
        id: 0,
        reply: ''
      },
      modelFuKuanShenHe: {
        id: '',
        orderid: '',
        shenqingdanwei: '',
        shenqingshijian: '',
        amount: ''
      },
      keywords: {
        begintime: '',
        endtime: '',
        orderid: '',
        projectname: '',
        shenqingdanwei: '',
        reviewstatus: '-1',
        paystatus: '-1'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogShenPi: false,
      dialogSubmitAgain: false,
      dialogFuKuanShenQing: false,
      apiShenPiErp6PurchaseOrderFuKuanShenHeUrl: '',
      SubRule_Erp6PurchaseOrderFuKuanShenHe_Add: false,
      SubRule_Erp6PurchaseOrderFuKuanShenHe_CaiGou: false,
      SubRule_Erp6PurchaseOrderFuKuanShenHe_CaiWu: false,
      SubRule_Erp6PurchaseOrderFuKuanShenHe_Zong: false,
      SubRule_Erp6PurchaseOrderFuKuanShenHe_ChuNa: false
    }
  },
  mounted () {
    this.useriderp = localStorage.getItem('Useriderp')

    this.apiGetErp6PurchaseOrderFuKuanShenHeNum()
    this.apiGetErp6PurchaseOrderFuKuanShenHeList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Erp6PurchaseOrderFuKuanShenHe_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6PurchaseOrderFuKuanShenHe_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6PurchaseOrderFuKuanShenHe_CaiGou', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6PurchaseOrderFuKuanShenHe_CaiGou = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6PurchaseOrderFuKuanShenHe_CaiWu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6PurchaseOrderFuKuanShenHe_CaiWu = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6PurchaseOrderFuKuanShenHe_Zong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6PurchaseOrderFuKuanShenHe_Zong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6PurchaseOrderFuKuanShenHe_ChuNa', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6PurchaseOrderFuKuanShenHe_ChuNa = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6PurchaseOrderFuKuanShenHeNum()
      this.apiGetErp6PurchaseOrderFuKuanShenHeList()
    },
    clickEdit (row) {
      this.dialogFuKuanShenQing = true
      this.modelFuKuanShenHe.id = row.Id
      this.modelFuKuanShenHe.orderid = row.Orderid
      this.modelFuKuanShenHe.shenqingdanwei = row.Shenqingdanwei
      this.modelFuKuanShenHe.shenqingshijian = row.Shenqingshijian
      this.modelFuKuanShenHe.amount = row.Amount
    },
    clickReturn () {
      this.activeName = 'first'
    },
    ShenHe0 (row) {
      this.dialogSubmitAgain = true
      this.modelSubmitAgain.id = row.Id
      this.modelSubmitAgain.reply = ''
    },
    ShenHe123 (row, number) {
      this.dialogShenPi = true
      this.modelShenPi.id = row.Id
      this.modelShenPi.opinion = ''
      if (number === 1) {
        this.apiShenPiErp6PurchaseOrderFuKuanShenHeUrl = Vue.prototype.global.Url_ShenPiErp6PurchaseOrderFuKuanShenHe1
      }
      if (number === 2) {
        this.apiShenPiErp6PurchaseOrderFuKuanShenHeUrl = Vue.prototype.global.Url_ShenPiErp6PurchaseOrderFuKuanShenHe2
      }
      if (number === 3) {
        this.apiShenPiErp6PurchaseOrderFuKuanShenHeUrl = Vue.prototype.global.Url_ShenPiErp6PurchaseOrderFuKuanShenHe3
      }
    },
    ShenHeOK () {
      this.dialogShenPi = false
      this.apiShenPiErp6PurchaseOrderFuKuanShenHe(1)
    },
    ShenHeNO () {
      this.dialogShenPi = false
      this.apiShenPiErp6PurchaseOrderFuKuanShenHe(-1)
    },
    SubmitAgain () {
      this.dialogSubmitAgain = false
      this.apiShenPiErp6PurchaseOrderFuKuanShenHe0()
    },
    clickDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelErp6PurchaseOrderFuKuanShenHe(row.Id)
      })
    },
    clickChuNa (row) {
      this.$confirm('是否设置为已支付?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiShenPiErp6PurchaseOrderFuKuanShenHeChuNa(row.Id)
      })
    },
    clickSearch () {
      this.selectedPageNo = 1
      this.apiGetErp6PurchaseOrderFuKuanShenHeNum()
      this.apiGetErp6PurchaseOrderFuKuanShenHeList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6PurchaseOrderFuKuanShenHeList()
    },
    apiGetErp6PurchaseOrderFuKuanShenHeNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        orderid: that.keywords.orderid,
        shenqingdanwei: that.keywords.shenqingdanwei,
        reviewstatus: that.keywords.reviewstatus,
        paystatus: that.keywords.paystatus,
        projectname: that.keywords.projectname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6PurchaseOrderFuKuanShenHeNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6PurchaseOrderFuKuanShenHeList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        orderid: that.keywords.orderid,
        shenqingdanwei: that.keywords.shenqingdanwei,
        reviewstatus: that.keywords.reviewstatus,
        paystatus: that.keywords.paystatus,
        projectname: that.keywords.projectname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6PurchaseOrderFuKuanShenHeList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelErp6PurchaseOrderFuKuanShenHe: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelErp6PurchaseOrderFuKuanShenHe, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderFuKuanShenHeNum()
            that.apiGetErp6PurchaseOrderFuKuanShenHeList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiErp6PurchaseOrderFuKuanShenHe: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.modelShenPi.id,
        opinion: that.modelShenPi.opinion,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiErp6PurchaseOrderFuKuanShenHeUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderFuKuanShenHeNum()
            that.apiGetErp6PurchaseOrderFuKuanShenHeList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiErp6PurchaseOrderFuKuanShenHe0: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.modelSubmitAgain.id,
        reply: that.modelSubmitAgain.reply
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShenPiErp6PurchaseOrderFuKuanShenHe0, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderFuKuanShenHeNum()
            that.apiGetErp6PurchaseOrderFuKuanShenHeList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiErp6PurchaseOrderFuKuanShenHeChuNa: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShenPiErp6PurchaseOrderFuKuanShenHeChuNa, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderFuKuanShenHeNum()
            that.apiGetErp6PurchaseOrderFuKuanShenHeList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditErp6PurchaseOrderFuKuanShenHe: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.modelFuKuanShenHe.id,
        orderid: that.modelFuKuanShenHe.orderid,
        shenqingdanwei: that.modelFuKuanShenHe.shenqingdanwei,
        shenqingshijian: that.modelFuKuanShenHe.shenqingshijian,
        amount: that.modelFuKuanShenHe.amount
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp6PurchaseOrderFuKuanShenHe, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderFuKuanShenHeNum()
            that.apiGetErp6PurchaseOrderFuKuanShenHeList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
